import { CustomFieldEntityEnum } from '@monetize/types/app';
import { useMemo } from 'react';
import { sortCustomFields } from '../utils/customFields';
import { useCustomFields } from './useCustomFields';

/**
 * The QUOTE_OFFERING_GROUP custom fields the tenant has configured, in the same
 * order CustomFieldDataForm renders them.
 *
 * Group UI hides its custom field affordances outright when a tenant has none —
 * a popover that only ever says "no fields" is worse than no icon at all — so
 * callers need the configured list, not just the values stored on a group.
 * Backed by the same react-query key as the form, so this costs no extra
 * request wherever the form is already mounted.
 */
export const useQuoteOfferingGroupCustomFields = () => {
  const { customFieldList, isLoading } = useCustomFields(
    CustomFieldEntityEnum.QUOTE_OFFERING_GROUP,
  );

  const customFields = useMemo(
    () => [...customFieldList].sort(sortCustomFields),
    [customFieldList],
  );

  return {
    customFields,
    hasCustomFields: customFields.length > 0,
    isLoading,
  };
};
